import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';

@Component({
  selector: 'app-perfil-empresa',
  templateUrl: './perfil-empresa.component.html',
  styleUrls: ['./perfil-empresa.component.scss'],
})
export class PerfilEmpresaComponent implements OnInit {
  isLoadingResults = false;
  perfilFormGroup: UntypedFormGroup;
  configuracionFormGroup: UntypedFormGroup;
  public fotoPerfil = '../../../../assets/images/sinFoto.png';
  fileToUpload: File | null = null;
  cambioImg = false;

  constructor(
    private alertify: AlertifyService,
    private _formBuilder: UntypedFormBuilder,
    private empresaSvc: EmpresaService,
    public router: Router
  ) {}

  ngOnInit() {
    this.perfilFormGroup = this._formBuilder.group({
      razonSocial: ['', Validators.required],
      direccion: [''],
      telefono: [''],
      celular: ['', Validators.required],
      email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
    });

    this.getDataEmpresa();
  }

  getDataEmpresa(): void {
    this.empresaSvc.getDatosEmpresa().subscribe(
      (result) => {
        console.log(result);
   



          if (result.logo.length > 1) {
            this.fotoPerfil = result.logo;
          }
          this.perfilFormGroup.get('razonSocial')?.setValue(result.razonSocial);
          this.perfilFormGroup.get('direccion')?.setValue(result.direccion);
          this.perfilFormGroup.get('telefono')?.setValue(result.telefono);
          this.perfilFormGroup.get('celular')?.setValue(result.celular);
          this.perfilFormGroup.get('email')?.setValue(result.email);
       
      },
      (error) => {
        console.log(error);
        this.alertify.error(
          'Ha ocurrido un error al cargar el perfil. Intentelo de nuevo.'
        );
      //  this.router.navigate(['/in']);
      }
    );
  }

  /* Actualizacion del perfil de la empresa luego de Finalizar el Formulario */
  actualizarEmpresa() {
    //Objeto con los datos del perfil de la empresa
    let empresa = this.perfilFormGroup.value;

    this.empresaSvc.actualizarDatosEmpresa(empresa).subscribe(
      (result) => {
        console.log(result);
        if (result) {
          if (this.cambioImg) {
            this.uploadFileToActivity();
          }
          this.alertify.success('La actualización del perfil ha sido exitosa.');
        } else {
          this.alertify.error(
            'Ha ocurrido un error al actualizar el perfil. Intentelo de nuevo.'
          );
        }
      },
      (error) => {
        console.log(error);
        this.alertify.error(
          'Ha ocurrido un error al actualizar el perfil. Intentelo de nuevo.'
        );
      }
    );
  }

  showPreviewImage(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      const files = event.target.files;
      var fileToUploadTmp = files.item(0);
      var size =
        fileToUploadTmp == null ? 0 : Math.round(fileToUploadTmp.size / 1024);
      console.log('size: ', size);
      var maxUploadSize = 500;
      if (size <= maxUploadSize) {
        //  this.cambioEnLogo = true;
        reader.onload = (event: any) => {
          this.fileToUpload = files.item(0);
          this.fotoPerfil = event.target.result;
          this.cambioImg = true;
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this.alertify.error(
          'La imagen debe ser menor a 500 Kb y un tamaño máximo de 720x720 px'
        );
      }
    }
  }

  uploadFileToActivity() {
    console.log('sube archivos');

    this.empresaSvc.actualizarImagen(this.fileToUpload).subscribe((res1) => {
      if (res1) {
        this.cambioImg = false;
        this.alertify.success('El logo fue guardado');
      } else {
        this.alertify.error(
          'La imagen debe tener un máximo de 720x720 px'
        );
      }
    });
  }
}
